export default __webpack_public_path__ + "static/media/PaperPlaneRight.d9c8d1da.svg";